import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {IUnderwriterInsurerMySuffix} from 'src/app/shared/model/underwriter-insurer-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';


type EntityResponseType = HttpResponse<IUnderwriterInsurerMySuffix>;
type EntityArrayResponseType = HttpResponse<IUnderwriterInsurerMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class UnderwriterInsurerMySuffixService {
   
    private resourceUrl = SERVER_API_URL + 'api/underwriter-insurers';
    private underwriterInsurersURL = SERVER_API_URL + 'api/underwriter-insurers-list';
    private resourceUrlForUmr = SERVER_API_URL + 'api/underwriter-insurers/umr'

    constructor(private http: HttpClient) {}

    create(underwriterInsurer: IUnderwriterInsurerMySuffix): Observable<EntityResponseType> {
        return this.http.post<IUnderwriterInsurerMySuffix>(this.resourceUrl, underwriterInsurer, { observe: 'response' });
    }

    update(underwriterInsurer: IUnderwriterInsurerMySuffix, isUmrChanged : boolean): Observable<EntityResponseType> {
        return this.http.put<IUnderwriterInsurerMySuffix>(`${this.resourceUrl}/${isUmrChanged}`, underwriterInsurer, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterInsurerMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterInsurerMySuffix>(`${this.resourceUrl}/view/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterInsurerMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    queryWithUId(id: number, req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterInsurerMySuffix[]>(this.underwriterInsurersURL+'/info'+ '?uid=' + id, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    searchQuery(searchKey?: string, url?: string, id?: any, req?: any): Observable<HttpResponse<any[]>> {
        console.log('inside search', id);

        // const options = createRequestOption(req);
        searchKey = searchKey.trim().replace('+', '');
        return this.http.get<any[]>(this.resourceUrl + url + '?searchKey=' + searchKey, { params: { id: id }, observe: 'response' });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterInsurerMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }


    findByUnderwriterId(uid: number): Observable<EntityArrayResponseType> {
        return this.http.get<IUnderwriterInsurerMySuffix[]>(`${this.resourceUrl}/by-underwriter/${uid}`, { observe: 'response' });
    }

    deleteUmr(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrlForUmr}/${id}`, { observe: 'response' });
    }

    checkForUnderwriterInsurerInPolicies(id: any) {
        return this.http.get<any>(SERVER_API_URL+`api/check-for-underwriter-insurer-in-policies/${id}`, { observe: 'response' });
    }
    


}
